import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "antd/dist/reset.css";

// Garantir que o ponto de inserção de estilos exista antes de renderizar o aplicativo
if (typeof document !== "undefined" && document.head) {
  const styleInsertionPoint = document.head.querySelector(
    "#styles-insertion-point"
  );
  if (!styleInsertionPoint) {
    const insertionPoint = document.createComment("styles-insertion-point");
    document.head.insertBefore(insertionPoint, document.head.firstChild);
  }
}

const container = document.getElementById("root");
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(<App />);
/* versão antiga com StrictMode
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
*/

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
